var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.travelStep === 1)?_c('TravelCoverage'):_vm._e(),_vm._v(" "),(_vm.travelStep === 2)?_c('TravelQuotations'):_vm._e(),_vm._v(" "),(_vm.travelStep === 3)?_c('TravelPersonalData'):_vm._e(),_vm._v(" "),(_vm.travelStep === 4)?_c('TravelAuth'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }